import { useEffect } from 'react';

export const useSecurePay = (handlers: {
  onStartListeningSecurePay: () => void;
  onStopListeningSecurePay: () => void;
  clearTimeoutIds: () => void;
}) => {
  useEffect(() => {
    handlers.onStartListeningSecurePay();

    return () => handlers.onStopListeningSecurePay();
  }, [handlers]);

  useEffect(() => {
    return () => {
      handlers.clearTimeoutIds();
    };
    // do not add handlers to dependencies, because we need to clear timeout ids only when the component is unmounted
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
